import styled from 'styled-components'

const HorizontalLine = styled.hr`
  ${p => p.theme.phone} {
    ${({ mobileStyles = {} }) => mobileStyles}
  }
  ${({ styles = {} }) => styles}
`

export default HorizontalLine
